<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Список товаров
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <router-link
                        to="/admin/add-product"
                        class="btn ml-2 p-0 kt_notes_panel_toggle"
                        data-toggle="tooltip"
                        title=""
                        data-placement="right"
                        data-original-title="Check out more demos"
                        v-if="$parent.permissions.includes('product-manage')"
                      >
                        <span
                          class="
                            bg-secondary
                            h-30px
                            font-size-h5
                            w-30px
                            d-flex
                            align-items-center
                            justify-content-center
                            rounded-circle
                            shadow-sm
                          "
                        >
                          <svg
                            width="25px"
                            height="25px"
                            viewBox="0 0 16 16"
                            class="bi bi-plus white"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                            ></path>
                          </svg>
                        </span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div
                          id="product_wrapper"
                          class="dataTables_wrapper no-footer"
                        >
                          <div class="ptf-bar">
                            <div class="ptf-item ptf-limit">
                              <label>Показать</label>
                              <select
                                v-model="limit"
                                v-on:change="fetchproducts(1, limit)"
                              >
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                              </select>
                            </div>

                            <div class="ptf-item ptf-search">
                              <label>Поиск по названию</label>
                              <input
                                type="text"
                                placeholder="Название, ID, SKU, штрихкод..."
                                v-model="searchParameter"
                                @keyup="searchProducts()"
                              />
                            </div>

                            <div class="ptf-item">
                              <label>Категория</label>
                              <multiselect
                                class="ptf-multiselect"
                                v-model="selectedCategory"
                                :options="categories"
                                :custom-label="categoryLabel"
                                track-by="id"
                                placeholder="Поиск категории..."
                                selectLabel=""
                                selectedLabel=""
                                deselectLabel=""
                                :allow-empty="true"
                                @input="onCategorySelect"
                              ></multiselect>
                            </div>

                            <div class="ptf-item">
                              <label>Коллекция</label>
                              <select v-model="filterCollection" @change="applyFilters">
                                <option value="">Все коллекции</option>
                                <option v-for="col in collections" :key="'col' + col.id" :value="col.id">
                                  {{ collectionLabel(col) }}
                                </option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>Статус</label>
                              <select v-model="filterStatus" @change="applyFilters">
                                <option value="">Все статусы</option>
                                <option value="active">Активен</option>
                                <option value="inactive">Неактивен</option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>Остаток</label>
                              <select v-model="filterStock" @change="applyFilters">
                                <option value="">Любой остаток</option>
                                <option value="in_stock">В наличии</option>
                                <option value="out_of_stock">Нет в наличии</option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>Бренд</label>
                              <select v-model="filterBrand" @change="applyFilters">
                                <option value="">Все бренды</option>
                                <option v-for="brand in brandOptions" :key="'br' + brand.brand_id" :value="String(brand.brand_id)">
                                  {{ brand.brand_name }}{{ brand.is_b2b == 1 ? ' · B2B' : '' }}
                                </option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>B2B</label>
                              <select v-model="filterB2b" @change="applyFilters">
                                <option value="">Все</option>
                                <option value="visible">Видны в B2B</option>
                                <option value="hidden">Не видны в B2B</option>
                                <option value="switched_off">Выключены вручную</option>
                              </select>
                            </div>

                            <div class="ptf-item ptf-reset" v-if="hasActiveFilters">
                              <button @click="clearFilters" type="button">Сбросить фильтры</button>
                            </div>
                          </div>
                          <!-- A brand's worth at once - only once a brand is picked, so
                               what "all" means is on screen before anyone presses it. -->
                          <div class="b2b-bulk" v-if="selectedBrand">
                            <template v-if="selectedBrand.is_b2b == 1">
                              <span>Бренд <b>{{ selectedBrand.brand_name }}</b> в B2B.</span>
                              <button type="button" class="btn btn-sm btn-light-primary" :disabled="bulkBusy"
                                      @click="bulkB2b(true)">Показать в B2B все товары бренда</button>
                              <button type="button" class="btn btn-sm btn-light" :disabled="bulkBusy"
                                      @click="bulkB2b(false)">Скрыть из B2B все товары бренда</button>
                            </template>
                            <span v-else class="text-muted">
                              Бренд <b>{{ selectedBrand.brand_name }}</b> не участвует в B2B - его товары партнёрам не видны,
                              что бы ни стояло у товаров. Включается в разделе «Бренды».
                            </span>
                          </div>
                          <table
                            id="product"
                            class="display dataTable no-footer"
                            product="grid"
                          >
                            <thead class="text-body">
                              <tr product="row">
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 10px"
                                  @click="sorting('id')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'id'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'id'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  ID
                                </th>
                                <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="product: activate to sort column ascending" style="width: 20px;"></th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('title')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'title'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'title'
                                      ? 'sorting_desc'
                                      : 'sorting'">
                                    Название
                                </th>
<!--                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"-->
<!--                                  @click="sorting('category_name')"-->
<!--                                  :class="-->
<!--                                    (this.$data.sortType == 'asc' ||-->
<!--                                      this.$data.sortType == 'ASC') &&-->
<!--                                    this.$data.sortBy == 'category_name'-->
<!--                                      ? 'sorting_asc'-->
<!--                                      : (this.$data.sortType == 'desc' ||-->
<!--                                          this.$data.sortType == 'DESC') &&-->
<!--                                        this.$data.sortBy == 'category_name'-->
<!--                                      ? 'sorting_desc'-->
<!--                                      : 'sorting'">-->
<!--                                  Категория-->
<!--                                </th>-->
                                <th class="d-none sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('product_type')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_type'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_type'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                    Тип
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('price')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'price'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'price'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  Цена
                                </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="Purchase Price" style="width: 31.25px">
                                      Цена закупки
                                  </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="B2B Price" style="width: 31.25px"
                                      title="Цена закупки, умноженная на коэффициент бренда">
                                      Цена B2B
                                  </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="Discount Price" style="width: 31.25px">
                                      Цена со скидкой
                                  </th>
                                  <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                      @click="sorting('product_sku')"
                                      :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_sku'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_sku'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                      SKU
                                  </th>
                                  <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                      @click="sorting('product_availability_status')"
                                      :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_availability_status'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_availability_status'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                      Остаток
                                  </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('product_status')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_status'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_status'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  Состояние
                                </th>
                                <!-- Offered to wholesale partners: a switch of its own,
                                     apart from the retail shop's state beside it. -->
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" style="width: 31.25px"
                                  title="Показывать товар в B2B. Действует, только если бренд участвует в B2B."
                                  @click="sorting('b2b_enabled')"
                                  :class="
                                    (sortType == 'asc' || sortType == 'ASC') && sortBy == 'b2b_enabled'
                                      ? 'sorting_asc'
                                      : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'b2b_enabled'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  B2B
                                </th>
                                <!--<th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('product_status_ee')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_status_ee'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_status_ee'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  Состояние EE
                                </th>-->
                                <th v-if="$parent.permissions.includes('product-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 20px">
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <template v-for="product in products">
                                <tr class="kt-table-row kt-table-row-level-0 odd" product="row" v-bind:key="product.id">
                                  <!-- ID -->
                                  <td class="sorting_1" style="text-align: center;font-weight: bold">{{ product.product_id }}</td>
                                  <td><img alt="" style="width: 50px;border-radius: 5px;" :src="typeof(product.image) !== null ? product.image : '' "/></td>
                                  <!-- Название -->
                                  <td>
                                    {{
                                      product.product_title == null
                                        ? ""
                                        : product.product_title
                                    }}
                                  </td>

                                  <td class="d-none">{{ product.product_type }}</td>

                                  <!-- Цена -->
                                  <td>
                                    <div class="inline-editor-cell">
                                      <div v-if="product.product_discount_price_symbol > 0">
                                        {{ (product.product_discount_price_symbol).toFixed(2) }} € <br>
                                        <span style="text-decoration:line-through; color: #aaa;">
                                          {{ (product.product_price).toFixed(2) }} €
                                        </span>
                                      </div>
                                      <div v-else>
                                        {{ (product.product_price).toFixed(2) }} €
                                      </div>

                                      <button
                                        type="button"
                                        class="btn btn-link p-0 inline-editor-trigger"
                                        @click.stop="enableEdit(product)"
                                        title="Edit"
                                      >
                                        <i class="fas fa-edit text-primary fa-lg"></i>
                                      </button>

                                      <div v-if="product.isEditing" class="inline-editor-dropdown inline-editor-dropdown--medium card shadow-sm border-0">
                                        <div class="card-body p-2">
                                          <div class="inline-editor-form-line">
                                            <input
                                              v-model.number="product.product_price"
                                              type="number"
                                              step="0.01"
                                              class="form-control form-control-sm inline-editor-form-input"
                                              placeholder="Цена"
                                              @keyup.enter="savePrice(product)"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-link p-0 inline-editor-trigger inline-editor-form-save"
                                              @click.stop="savePrice(product)"
                                              title="Сохранить"
                                            >
                                              <i class="fas fa-save text-success fa-lg"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <!-- Цена закупки -->
                                  <td>
                                    <div class="inline-editor-cell">
                                      <div v-if="product.purchase_price">
                                        {{ (product.purchase_price).toFixed(2) }} €
                                      </div>
                                      <div v-else style="color: #aaa;">
                                        —
                                      </div>

                                      <button
                                        type="button"
                                        class="btn btn-link p-0 inline-editor-trigger"
                                        @click.stop="enableEditPurchasePrice(product)"
                                        title="Edit"
                                      >
                                        <i class="fas fa-edit text-primary fa-lg"></i>
                                      </button>

                                      <div v-if="product.isEditingPurchasePrice" class="inline-editor-dropdown inline-editor-dropdown--small card shadow-sm border-0">
                                        <div class="card-body p-2">
                                          <div class="inline-editor-form-line">
                                            <input
                                              v-model.number="product.purchase_price"
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              class="form-control form-control-sm inline-editor-form-input"
                                              placeholder="Цена закупки"
                                              @keyup.enter="savePurchasePrice(product)"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-link p-0 inline-editor-trigger inline-editor-form-save"
                                              @click.stop="savePurchasePrice(product)"
                                              title="Сохранить"
                                            >
                                              <i class="fas fa-save text-success fa-lg"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <!-- Цена B2B -->
                                  <td>
                                    <div class="inline-editor-cell">
                                      <div v-if="product.b2b_price">
                                        {{ Number(product.b2b_price).toFixed(2) }} €
                                        <!-- Where the figure came from: typed in by
                                             hand, or the brand factor applied to the
                                             purchase price. -->
                                        <div v-if="product.b2b_price_manual"
                                             style="color: #b8860b; font-size: 12px;"
                                             :title="'по коэффициенту было бы ' + (product.b2b_price_calculated ? Number(product.b2b_price_calculated).toFixed(2) + ' €' : '—')">
                                          вручную
                                        </div>
                                        <div v-else style="color: #888; font-size: 12px;"
                                             :title="'закупка x ' + product.b2b_price_factor">
                                          x{{ product.b2b_price_factor }}
                                        </div>
                                      </div>
                                      <div v-else style="color: #aaa;">—</div>

                                      <button
                                        type="button"
                                        class="btn btn-link p-0 inline-editor-trigger"
                                        @click.stop="enableEditB2bPrice(product)"
                                        title="Edit"
                                      >
                                        <i class="fas fa-edit text-primary fa-lg"></i>
                                      </button>

                                      <div v-if="product.isEditingB2bPrice" class="inline-editor-dropdown inline-editor-dropdown--medium card shadow-sm border-0">
                                        <div class="card-body p-2">
                                          <div class="inline-editor-form-line">
                                            <input
                                              v-model="product.b2b_price_input"
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              class="form-control form-control-sm inline-editor-form-input"
                                              placeholder="Цена B2B"
                                              @keyup.enter="saveB2bPrice(product)"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-link p-0 inline-editor-trigger inline-editor-form-save"
                                              @click.stop="saveB2bPrice(product)"
                                              title="Сохранить"
                                            >
                                              <i class="fas fa-save text-success fa-lg"></i>
                                            </button>
                                          </div>
                                          <small class="form-text text-muted">
                                            Пусто — цена снова считается по коэффициенту бренда.
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <!-- Цена со скидкой -->
                                  <td>
                                    <div class="inline-editor-cell">
                                      <div v-if="product.discount_price > 0">
                                        {{ (product.discount_price).toFixed(2) }} €
                                        <div v-if="product.discount_end_at" style="font-size: 11px; color: #666;">
                                          до {{ formatDiscountEndDate(product.discount_end_at) }}
                                        </div>
                                      </div>
                                      <div v-else style="color: #aaa;">
                                        —
                                      </div>

                                      <button
                                        type="button"
                                        class="btn btn-link p-0 inline-editor-trigger"
                                        @click.stop="enableEditDiscountPrice(product)"
                                        title="Edit"
                                      >
                                        <i class="fas fa-edit text-primary fa-lg"></i>
                                      </button>

                                      <div v-if="product.isEditingDiscountPrice" class="inline-editor-dropdown inline-editor-dropdown--large card shadow-sm border-0">
                                        <div class="card-body p-2">
                                          <div class="inline-editor-form-line inline-editor-form-line--discount">
                                            <input
                                              v-model.number="product.discount_price"
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              class="form-control form-control-sm inline-editor-form-input inline-editor-form-input--discount"
                                              placeholder="Цена со скидкой"
                                              @keyup.enter="saveDiscountPrice(product)"
                                            />
                                            <input
                                              v-model="product.discount_end_at"
                                              type="date"
                                              class="form-control form-control-sm inline-editor-form-input inline-editor-form-input--date"
                                              title="Действует до"
                                              @keyup.enter="saveDiscountPrice(product)"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-link p-0 inline-editor-trigger inline-editor-form-save"
                                              @click.stop="saveDiscountPrice(product)"
                                              title="Сохранить"
                                            >
                                              <i class="fas fa-save text-success fa-lg"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <!-- SKU -->
                                  <td>{{ product.product_sku }}</td>

                                  <!-- Остаток -->
                                  <td class="text-right">
                                    <div v-if="product.product_type === 'variable' && product.combinations && product.combinations.length > 0" class="inline-editor-cell justify-content-end">
                                      <span>{{ (product.available_qty) }}</span>
                                      <button
                                        type="button"
                                        class="btn btn-link p-0 inline-editor-trigger"
                                        @click.stop="toggleCombinations(product)"
                                        title="Показать вариации"
                                      >
                                        <i class="fas fa-edit text-primary fa-lg"></i>
                                      </button>

                                      <div v-if="product.showCombinations" class="inline-editor-dropdown inline-editor-dropdown--stock card shadow-sm border-0">
                                        <div class="card-body p-2">
                                          <div class="d-flex align-items-center justify-content-between mb-2">
                                            <strong class="text-body">Вариации</strong>
                                            <button
                                              type="button"
                                              class="btn btn-link p-0 text-muted"
                                              @click.stop="toggleCombinations(product)"
                                              title="Закрыть"
                                            >
                                              <i class="fas fa-times"></i>
                                            </button>
                                          </div>

                                          <div
                                            v-for="combination in product.combinations"
                                            :key="combination.id"
                                            class="stock-combination-row"
                                          >
                                            <div class="stock-combination-row__title">
                                              {{ combination.combination_string || combination.sku || '—' }}
                                            </div>

                                            <div class="stock-combination-row__actions">
                                              <input
                                                v-model.number="combination.available_qty"
                                                type="number"
                                                step="1"
                                                min="0"
                                                class="form-control form-control-sm stock-combination-row__input"
                                                @keyup.enter="saveCombinationQuantity(product, combination)"
                                              />
                                              <button
                                                type="button"
                                                class="btn btn-link p-0 inline-editor-trigger stock-combination-row__save"
                                                @click.stop="saveCombinationQuantity(product, combination)"
                                                title="Сохранить"
                                              >
                                                <i class="fas fa-save text-success"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <div class="inline-editor-cell justify-content-end" style="display: flex;">
                                        {{ (product.available_qty) }}
                                        <button
                                          type="button"
                                          class="btn btn-link p-0 inline-editor-trigger"
                                          @click.stop="enableEditQty(product)"
                                          title="Edit"
                                        >
                                          <i class="fas fa-edit text-primary fa-lg"></i>
                                        </button>
                                      <div v-if="product.isEditingQty" class="inline-editor-dropdown inline-editor-dropdown--small card shadow-sm border-0">
                                          <div class="card-body p-2">
                                            <div class="inline-editor-form-line">
                                              <input
                                                v-model.number="product.available_qty"
                                                type="number"
                                                step="1"
                                                min="0"
                                                class="form-control form-control-sm inline-editor-form-input"
                                                placeholder="Количество"
                                                @keyup.enter="saveQuantity(product)"
                                              />
                                              <button
                                                type="button"
                                                class="btn btn-link p-0 inline-editor-trigger inline-editor-form-save"
                                                @click.stop="saveQuantity(product)"
                                                title="Сохранить"
                                              >
                                                <i class="fas fa-save text-success fa-lg"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <!-- Состояние -->
                                  <td class="text-center">
                                      <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                          <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="`customSwitchStatus${product.product_id}`"
                                              :checked="product.product_status === 'active'"
                                              v-on:input="(event) => { setProductStatus(event.target.checked, product) }"
                                          />
                                          <label class="custom-control-label mr-1" :for="`customSwitchStatus${product.product_id}`"></label>
                                      </div>
                                  </td>

                                  <!-- B2B. Three looks, one meaning each: greyed and not
                                       clickable when the brand is not in B2B at all; an
                                       ordinary switch otherwise, on or off. -->
                                  <td class="text-center">
                                      <div class="custom-control switch custom-switch custom-control-inline mr-0"
                                           :class="product.brand_in_b2b ? 'custom-switch-info' : 'b2b-switch-inert'"
                                           :title="product.brand_in_b2b
                                              ? (product.b2b_enabled ? 'Виден в B2B' : 'Скрыт из B2B')
                                              : 'Бренд ' + (product.brand_name || '') + ' не участвует в B2B. '
                                                + (product.b2b_enabled
                                                    ? 'Если бренд включат, товар будет виден.'
                                                    : 'Товар выключен и останется скрытым, даже если бренд включат.')">
                                          <!-- Drawn empty while the brand is out: the product's own
                                               setting is kept, and said in the tooltip, but a switch
                                               that looks on for something no partner can see misleads. -->
                                          <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="`customSwitchB2b${product.product_id}`"
                                              :checked="product.brand_in_b2b && product.b2b_enabled"
                                              :disabled="!product.brand_in_b2b"
                                              @change="(event) => setB2bEnabled(event.target.checked, product, event)"
                                          />
                                          <label class="custom-control-label mr-1" :for="`customSwitchB2b${product.product_id}`"></label>
                                      </div>
                                  </td>

                                  <!-- Состояние EE -->
                                  <!--<td class="text-center">
                                      <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                          <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="`customSwitchStatusEE${product.product_id}`"
                                              :checked="product.product_status_ee === 'active'"
                                              v-on:input="(event) => { setProductStatusEE(event.target.checked, product) }"
                                          />
                                          <label class="custom-control-label mr-1" :for="`customSwitchStatusEE${product.product_id}`"></label>
                                      </div>
                                  </td>-->

                                  <!-- Actions -->
                                  <td v-if="$parent.permissions.includes('product-manage')">
                                      <router-link
                                          :to="{path:'/admin/add-product/' + product.product_id,}"
                                          class="btn ml-2 p-0 kt_notes_panel_toggle"
                                          data-toggle="tooltip"
                                          title=""
                                          data-placement="right"
                                          data-original-title="Copy"
                                          v-if="$parent.permissions.includes('product-manage')"
                                      ><i class="fa fa-copy"></i>
                                      </router-link>
                                      <router-link
                                      :to="{path:'/admin/product/' + product.product_id,}"
                                      class="click-edit"
                                      id="click-edit1"
                                      data-toggle="tooltip"
                                      title=""
                                      data-placement="right"
                                      data-original-title="Edit"
                                      @click="editproduct(product)"
                                      ><i class="fa fa-edit"></i>
                                    </router-link>
                                    <a class="" href="#" @click="deleteproduct(product.product_id)"><i class="fa fa-trash"></i></a>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                          <Pagination :currentPage="pagination.current_page" :totalPage="pagination.last_page" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        "
      >
        <h4 class="font-size-h4 font-weight-bold m-0">Добавить товар</h4>
        <a
          href="#"
          class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          "
          v-on:click="display_form = 0"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Name </label>
              <input
                type="text"
                name="text"
                v-model="product.name"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('name')"
                v-text="errors.get('name')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Direction </label>
              <select v-model="product.direction">
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('direction')"
                v-text="errors.get('direction')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Code </label>
              <input
                type="text"
                name="text"
                v-model="product.code"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('code')"
                v-text="errors.get('code')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Directory </label>
              <input
                type="text"
                name="text"
                v-model="product.directory"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('directory')"
                v-text="errors.get('directory')"
              ></small>
            </div>
            <div class="form-group">
              <input
                type="checkbox"
                name="text"
                v-model="product.is_default"
                id="is_default"
                class="form-check-input"
              />
              <label class="text-dark" for="is_default">Set as default </label>
              <small
                class="form-text text-danger"
                v-if="errors.has('is_default')"
                v-text="errors.get('is_default')"
              ></small>
            </div>
          </div>
        </div>
        <button
          type="button"
          @click="addUpdateproduct()"
          class="btn btn-primary"
        >
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import Pagination from './Pagination';
import Multiselect from "vue-multiselect";
export default {
  data() {
    return {
      timer: null,
      display_form: 0,
      products: [],
      searchParameter: this.$route.query.searchParameter || null,
      categories: [],
      collections: [],
      selectedCategory: null,
      filterCategory: this.$route.query.productCategories || '',
      filterCollection: this.$route.query.productCollections || '',
      filterStatus: this.$route.query.productStatus || '',
      filterStock: this.$route.query.stockStatus || '',
      filterBrand: this.$route.query.productBrand || '',
      filterB2b: this.$route.query.b2bVisibility || '',
      brandOptions: [],
      bulkBusy: false,
      sortBy: "id",
      sortType: "DESC",
      limit: this.$route.query.limit || 50,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {
        current_page: null,
        last_page: 1
      },
      request_method: "",
      is_default: "0",
      token: [],
      currency: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      statusText: {
          in_storage: 'на складе',
          in_stock: 'в наличии',
          preorder: 'предзаказ'
      },
    };
  },
  components:{
    Pagination,
    Multiselect
  },

  computed: {
    hasActiveFilters() {
      return Boolean(
        this.filterCategory || this.filterCollection ||
        this.filterStatus || this.filterStock || this.searchParameter ||
        this.filterBrand || this.filterB2b
      );
    },
    selectedBrand() {
      return this.filterBrand
        ? this.brandOptions.find(b => String(b.brand_id) === String(this.filterBrand)) || null
        : null;
    },
  },

  methods: {
      applyFilters() {
        this.fetchproducts(1);
      },
      clearFilters() {
        this.filterCategory = '';
        this.selectedCategory = null;
        this.filterCollection = '';
        this.filterStatus = '';
        this.filterStock = '';
        this.filterBrand = '';
        this.filterB2b = '';
        this.searchParameter = '';
        this.fetchproducts(1);
      },
      categoryLabel(cat) {
        if (!cat) return '';
        const detail = this.localisedDetail(cat.detail);
        return detail ? detail.name : ('#' + cat.id);
      },
      collectionLabel(col) {
        if (!col) return '';
        if (col.full_path) return col.full_path;
        const detail = this.localisedDetail(col.details || col.detail);
        return detail ? (detail.collection_name || detail.name) : ('#' + col.id);
      },
      /**
       * Dictionary rows come one per language; pick the default one rather than
       * whichever the query returned first.
       */
      localisedDetail(entries) {
        if (!Array.isArray(entries) || !entries.length) return null;
        const languageId = (window.appConfig && window.appConfig.defaultLanguageId) || null;
        const match = languageId
          ? entries.find(e => Number(e.language_id) === Number(languageId))
          : null;
        return match || entries[0];
      },
      onCategorySelect(val) {
        this.filterCategory = val ? val.id : '';
        this.fetchproducts(1);
      },
      fetchFilterDictionaries() {
        axios.get('/api/admin/category?getAllData=1&getDetail=1', this.token)
          .then(res => {
            this.categories = (res.data && res.data.data) || [];
            if (this.filterCategory) {
              this.selectedCategory = this.categories.find(c => String(c.id) === String(this.filterCategory)) || null;
            }
          })
          .catch(() => {});

        axios.get('/api/admin/collection?getAllData=1&getDetail=1', this.token)
          .then(res => { this.collections = (res.data && res.data.data) || []; })
          .catch(() => {});

        axios.get('/api/admin/brand?limit=1000&sortBy=name&sortType=asc', this.token)
          .then(res => { this.brandOptions = (res.data && res.data.data) || []; })
          .catch(() => {});
      },

      /**
       * One product in or out of B2B. The switch moves at once and goes back if
       * the save fails, so what is on screen is never a state that was not kept.
       */
      setB2bEnabled(value, product, event) {
        const before = product.b2b_enabled;
        product.b2b_enabled = value;

        axios.put(`/api/admin/product/${product.product_id}/b2b-enabled`, { b2b_enabled: value }, this.token)
          .then(res => {
            this.$toaster.success(value ? 'Товар виден в B2B' : 'Товар скрыт из B2B');
          })
          .catch(() => {
            product.b2b_enabled = before;
            if (event && event.target) {
              event.target.checked = before;
            }
            this.$toaster.error('Не удалось сохранить');
          });
      },

      /**
       * Every product of the picked brand, across all pages - not only the ones
       * the current page shows. Asks first, with the number, because this is the
       * one action here that touches more than one row.
       */
      bulkB2b(value) {
        const brand = this.selectedBrand;

        if (!brand) {
          return;
        }

        const count = brand.products_count || 0;
        const question = value
          ? `Показать в B2B все товары бренда ${brand.brand_name} (${count})?`
          : `Скрыть из B2B все товары бренда ${brand.brand_name} (${count})?`;

        if (!confirm(question)) {
          return;
        }

        this.bulkBusy = true;

        axios.put('/api/admin/product/b2b-enabled', { brand_id: brand.brand_id, b2b_enabled: value }, this.token)
          .then(res => {
            const changed = res.data && res.data.data ? res.data.data.changed : 0;
            this.$toaster.success(`Изменено товаров: ${changed}`);
            this.fetchproducts(this.getCurrentPage());
            this.fetchFilterDictionaries();
          })
          .catch(() => this.$toaster.error('Не удалось сохранить'))
          .finally(() => { this.bulkBusy = false; });
      },
      getCurrentPage() {
        const routePage = Number(this.$route.query.page);
        if (!Number.isNaN(routePage) && routePage > 0) {
          return routePage;
        }

        const paginationPage = Number(this.pagination.current_page);
        if (!Number.isNaN(paginationPage) && paginationPage > 0) {
          return paginationPage;
        }

        return 1;
      },

      refreshCurrentPage() {
        this.fetchproducts(this.getCurrentPage(), this.limit, this.searchParameter);
      },

      buildProductsQuery(page, limit, searchParameter) {
        const query = {
          ...this.$route.query,
          page: String(page),
          limit: String(limit),
        };

        if (searchParameter) {
          query.searchParameter = searchParameter;
        } else {
          delete query.searchParameter;
        }

        query.sortBy = this.sortBy;
        query.sortType = this.sortType;

        // Filters travel through the address, and fetchproducts forwards
        // everything from there to the API - so the view survives a reload
        // and can be shared as a link.
        const filters = {
          productCategories: this.filterCategory,
          productCollections: this.filterCollection,
          productStatus: this.filterStatus,
          stockStatus: this.filterStock,
          productBrand: this.filterBrand,
          b2bVisibility: this.filterB2b,
        };

        Object.entries(filters).forEach(([key, value]) => {
          if (value === '' || value === null || value === undefined) {
            delete query[key];
          } else {
            query[key] = String(value);
          }
        });

        return query;
      },

      toggleCombinations(product) {
        if (product.showCombinations) {
          this.closeCombinationDropdown(product);
          return;
        }

        this.closeAllEditors();
        product.combinations.forEach((combination) => {
          combination.original_qty = combination.available_qty;
          this.$set(combination, 'isEditingQty', false);
        });
        this.$set(product, 'showCombinations', true);
      },

      closeCombinationDropdown(product) {
        if (product.combinations && Array.isArray(product.combinations)) {
          product.combinations.forEach((combination) => {
            if (typeof combination.original_qty !== 'undefined') {
              combination.available_qty = combination.original_qty;
            }
          });
        }

        this.$set(product, 'showCombinations', false);
      },

      saveCombinationQuantity(product, combination) {
        this.$parent.loading = true;
        const data = {
          quantity: combination.available_qty,
          product_combination_id: combination.id,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/quantity`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);

              // Refresh products to get updated quantities
              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update combination quantity");
            } else {
              this.$toaster.error("An error occurred while updating the combination quantity");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      closeAllEditors() {
        this.products.forEach((product) => {
          if (product.isEditing) {
            product.product_price = product.original_price;
            this.$set(product, 'isEditing', false);
          }

          if (product.isEditingPurchasePrice) {
            product.purchase_price = product.original_purchase_price;
            this.$set(product, 'isEditingPurchasePrice', false);
          }

          if (product.isEditingDiscountPrice) {
            product.discount_price = product.original_discount_price;
            product.discount_end_at = product.original_discount_end_at;
            this.$set(product, 'isEditingDiscountPrice', false);
          }

          if (product.isEditingQty) {
            product.available_qty = product.original_qty;
            this.$set(product, 'isEditingQty', false);
          }

          if (product.isEditingB2bPrice) {
            this.$set(product, 'isEditingB2bPrice', false);
          }

          if (product.showCombinations) {
            this.closeCombinationDropdown(product);
          }

          if (product.combinations && Array.isArray(product.combinations)) {
            product.combinations.forEach((combination) => {
              if (typeof combination.original_qty !== 'undefined') {
                combination.available_qty = combination.original_qty;
              }
            });
          }
        });
      },

      enableEditB2bPrice(product) {
        if (product.isEditingB2bPrice) {
          this.$set(product, 'isEditingB2bPrice', false);
          return;
        }

        this.closeAllEditors();
        // Only a price set by hand is offered back for editing: showing the
        // worked-out figure would turn it into a manual one on the first save.
        this.$set(product, 'b2b_price_input', product.b2b_price_manual ? product.b2b_price : '');
        this.$set(product, 'isEditingB2bPrice', true);
      },
      saveB2bPrice(product) {
        this.$parent.loading = true;

        const token = localStorage.getItem("token");
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const value = product.b2b_price_input;

        axios
          .put(`/api/admin/product/${product.product_id}/b2b-price`, {
            // Empty means "back to the brand factor", so it is sent as null
            // rather than left out.
            b2b_price: (value === '' || value === null || typeof value === 'undefined') ? null : value,
          }, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingB2bPrice', false);
              this.refreshCurrentPage();
            } else {
              this.$toaster.error(res.data.message);
            }
          })
          .catch((error) => {
            const message = error.response && error.response.data && error.response.data.message;
            this.$toaster.error(message || "Не удалось сохранить цену B2B");
          })
          .finally(() => (this.$parent.loading = false));
      },
      enableEdit(product) {
        if (product.isEditing) {
          this.cancelEdit(product);
          return;
        }

        this.closeAllEditors();
        product.original_price = product.product_price;
        this.$set(product, 'isEditing', true);
      },

      cancelEdit(product) {
        product.product_price = product.original_price;
        this.$set(product, 'isEditing', false);
      },

      enableEditQty(product) {
        if (product.isEditingQty) {
          this.cancelEditQty(product);
          return;
        }

        this.closeAllEditors();
        product.original_qty = product.available_qty;
        this.$set(product, 'isEditingQty', true);
      },

      cancelEditQty(product) {
        product.available_qty = product.original_qty;
        this.$set(product, 'isEditingQty', false);
      },

      saveQuantity(product) {
        this.$parent.loading = true;
        const data = {
          quantity: product.available_qty,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/quantity`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingQty', false);

              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update quantity");
            } else {
              this.$toaster.error("An error occurred while updating the quantity");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      savePrice(product) {
        this.$parent.loading = true;
        const data = {
          product_price: product.product_price,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/price`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditing', false);

              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update price");
            } else {
              this.$toaster.error("An error occurred while updating the price");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      enableEditPurchasePrice(product) {
        if (product.isEditingPurchasePrice) {
          this.cancelEditPurchasePrice(product);
          return;
        }

        this.closeAllEditors();
        // Initialize purchase_price to 0 if it's null or undefined
        if (!product.purchase_price) {
          product.purchase_price = 0;
        }
        product.original_purchase_price = product.purchase_price;
        this.$set(product, 'isEditingPurchasePrice', true);
      },

      cancelEditPurchasePrice(product) {
        product.purchase_price = product.original_purchase_price;
        this.$set(product, 'isEditingPurchasePrice', false);
      },

      savePurchasePrice(product) {
        this.$parent.loading = true;
        const data = {
          purchase_price: product.purchase_price,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/purchase-price`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingPurchasePrice', false);

              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update purchase price");
            } else {
              this.$toaster.error("An error occurred while updating the purchase price");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      enableEditDiscountPrice(product) {
        if (product.isEditingDiscountPrice) {
          this.cancelEditDiscountPrice(product);
          return;
        }

        this.closeAllEditors();
        if (!product.discount_price) {
          product.discount_price = 0;
        }
        product.original_discount_price = product.discount_price;
        product.original_discount_end_at = product.discount_end_at || '';
        this.$set(product, 'isEditingDiscountPrice', true);
      },

      cancelEditDiscountPrice(product) {
        product.discount_price = product.original_discount_price;
        product.discount_end_at = product.original_discount_end_at;
        this.$set(product, 'isEditingDiscountPrice', false);
      },

      saveDiscountPrice(product) {
        this.$parent.loading = true;
        const data = {
          discount_price: product.discount_price,
          discount_end_at: product.discount_end_at || null,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/discount-price`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingDiscountPrice', false);

              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update discount price");
            } else {
              this.$toaster.error("An error occurred while updating the discount price");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      formatDiscountEndDate(value) {
        if (!value) {
          return '';
        }

        const [year, month, day] = value.split('-');
        if (!year || !month || !day) {
          return value;
        }

        return `${day}.${month}.${year}`;
      },

      getCategoryText(category){
          try {
              let text = '';
              return category.map((item) => {
                  return `${this.getParentCategoryText(item.category_detail)}`
              }).join(', ')
          } catch (e){
              console.log(e)
              return '';
          }

          console.log(category)

          return '';
      },
      getParentCategoryText(category){
          let text = '';
        if(category.parent_category) {
            text += this.getParentCategoryText(category.parent_category) + ' → ';
        }
        text += category.detail[0].name;
        return text;
      },
      // The switch moves the moment it is clicked; the request used to be
      // fired and forgotten, so a failed one (expired session, network) left
      // it looking switched while nothing was saved - and the next reload
      // showed the old state, as if something had switched it back.
      setProductStatus(value, product){
          this.saveStatus(product, 'product_status', value);
      },
      setProductStatusEE(value, product){
          this.saveStatus(product, 'product_status_ee', value);
      },
      saveStatus(product, field, value) {
          const before = product[field];
          product[field] = value ? 'active' : 'inactive';

          axios.put(`/api/admin/product/${product.product_id}/product-status`, {[field]: value}, this.token)
              .then(res => {
                  if (res.data && res.data.status === 'Error') {
                      throw new Error(res.data.message || 'Error');
                  }
                  this.$toaster.success(value ? 'Товар включён' : 'Товар выключен');
              })
              .catch(error => {
                  product[field] = before;
                  // Redraw the switch from the data, not from the click.
                  this.products = this.products.slice();
                  const message = error.response && error.response.data && error.response.data.message;
                  this.$toaster.error('Статус не сохранён' + (message ? ': ' + message : '') + '. Обновите страницу и попробуйте снова.');
              });
      },
    fetchCurrency() {
      this.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.currency = res.data.data;
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    searchProducts(){
        if(this.timer){
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.fetchproducts(1);
        }, 1000)
    },

    fetchproducts(page = null, limit = null, searchParameter = null) {
      this.pagination.current_page = page = page === null ? this.getCurrentPage() : Number(page);
      this.limit = limit = limit || this.limit;
      this.searchParameter = searchParameter = searchParameter || this.searchParameter;
      const query = this.buildProductsQuery(page, limit, searchParameter);

      this.$router.replace({ path: '/admin/products', query }).catch(() => {});

      this.$parent.loading = true;
      let page_url = `/api/admin/product/product-list?page=${page}&limit=${limit}`;

      if (searchParameter) {
        page_url += `&searchParameter=${encodeURIComponent(searchParameter)}`;
      }

      Object.entries(query).forEach(([key, value]) => {
        if (['page', 'limit', 'searchParameter', 'sortBy', 'sortType'].includes(key)) {
          return;
        }

        if (value !== null && value !== undefined && value !== '') {
          page_url += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      page_url += `&sortBy=${this.sortBy}&sortType=${this.sortType}&getDetail=1&getCategory=1`;

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.products = res.data.data.map((product) => {
            // Initialize each product
            const initializedProduct = {
              ...product,
              isEditing: false,
              isEditingQty: false,
              isEditingPurchasePrice: false,
              isEditingDiscountPrice: false,
              showCombinations: false,
            };

            // Initialize combinations if they exist
            if (initializedProduct.combinations && Array.isArray(initializedProduct.combinations)) {
              initializedProduct.combinations = initializedProduct.combinations.map(combination => ({
                ...combination,
                isEditingQty: false,
              }));
            }

            return initializedProduct;
          });
          this.makePagination(res.data.meta, res.data.links);
        })
        .finally(() => (this.$parent.loading = false));
    },

    makePagination(meta) {
      this.pagination.current_page = meta.current_page;
      this.pagination.last_page = meta.last_page;
    },

    sorting(sortBy) {
      this.sortBy = sortBy;
      this.sortType =
        this.sortType == "asc" || this.sortType == "ASC"
          ? (this.sortType = "desc")
          : (this.sortType = "asc");
      this.fetchproducts();
    },
    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },
    deleteproduct(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/product/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.refreshCurrentPage();
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
						if(error.response.data.status == 'Error'){
                             this.$toaster.error(error.response.data.message)
						} }
          })
          .finally(() => (this.$parent.loading = false));
      }
    },
    clearSearch(){
      this.searchParameter = "",
      this.fetchproducts();
    },
    handleDocumentClick(event) {
      if (!event.target.closest('.inline-editor-cell')) {
        this.closeAllEditors();
      }
    },
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCurrency();
    this.fetchFilterDictionaries();
    this.fetchproducts(this.getCurrentPage(), this.limit, this.searchParameter);

    document.addEventListener("click", this.handleDocumentClick);
    this.$on('page-changed', page => {
      this.fetchproducts(page);
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  props: ["loading"],
};
</script>

<style scoped>
/* A brand outside B2B: the switch is there, so the column reads the same on
   every row, but it is visibly not something to press. */
.b2b-switch-inert {
  cursor: not-allowed;
}

.b2b-switch-inert ::v-deep .custom-control-label::before {
  background-color: #f3f6f9 !important;
  border-color: #e4e6ef !important;
}

.b2b-switch-inert ::v-deep .custom-control-label::after {
  background-color: #d1d3e0 !important;
}

.b2b-switch-inert .custom-control-label {
  cursor: not-allowed;
}

.b2b-bulk {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  background: #f5f8fa;
  border-radius: 6px;
}

.inline-editor-cell {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
}

.inline-editor-trigger {
  color: inherit;
  text-decoration: none;
  line-height: 1;
}

.inline-editor-trigger:hover,
.inline-editor-trigger:focus {
  text-decoration: none;
}

.inline-editor-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 40;
  min-width: 240px;
}

.inline-editor-dropdown--small {
  width: 200px;
}

.inline-editor-dropdown--medium {
  width: 200px;
}

.inline-editor-dropdown--large {
  width: 320px;
}

.inline-editor-dropdown--stock {
  width: 320px;
  max-height: 340px;
  overflow-y: auto;
}

.inline-editor-cell--combination {
  justify-content: flex-end;
  min-width: 92px;
}

.stock-combination-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #edf0f5;
}

.stock-combination-row:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.stock-combination-row:first-of-type {
  padding-top: 0;
}

.stock-combination-row__title {
  min-width: 0;
  flex: 1;
  font-weight: 500;
  color: #3f4254;
  font-size: 12px;
  line-height: 1.2;
}

.stock-combination-row__actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.stock-combination-row__input {
  width: 64px;
  padding: 0.15rem 0.35rem;
  text-align: center;
}

.stock-combination-row__save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.inline-editor-form-line {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}

.inline-editor-form-line--discount {
  gap: 5px;
}

.inline-editor-form-input {
  min-width: 0;
  flex: 1 1 auto;
}

.inline-editor-form-input--discount {
  flex-basis: 115px;
}

.inline-editor-form-input--date {
  flex-basis: 120px;
}

.inline-editor-form-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.ptf-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
    margin: 0 0 16px 4px;
}
.ptf-item {
    display: flex;
    flex-direction: column;
    min-width: 170px;
}
.ptf-item label {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 4px;
}
.ptf-item select,
.ptf-item input {
    height: 38px;
    padding: 0 10px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    font-size: 14px;
}
.ptf-limit { min-width: 90px; }
.ptf-search { min-width: 240px; }
.ptf-reset { justify-content: flex-end; }
.ptf-reset button {
    height: 38px;
    padding: 0 14px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
}
/* Автокомплит рисует свою рамку — выравниваем по остальным полям. */
.ptf-multiselect .multiselect__tags {
    min-height: 38px;
    padding-top: 6px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}
.ptf-multiselect .multiselect__select { height: 36px; }
</style>
